module.exports = __webpack_public_path__ + "static/media/namemark.cb9316ae.png";